export default function toDegrees(radians) {
  return radians * (180 / Math.PI)
}
